/**
 * 🔐 认证Hook | Authentication Hook
 * 
 * 使用Clerk提供认证功能
 */

import { useUser, useAuth as useClerkAuth } from '@clerk/clerk-react';
import { useMemo } from 'react';

export type Role = 'admin' | 'qa' | 'dev' | 'reviewer';

export interface User {
  id: string;
  email: string;
  name: string;
  role: Role;
}

/**
 * 🎯 useAuth Hook
 * 
 * @returns { user, role, isLoaded, isSignedIn, signOut }
 */
export function useAuth() {
  const { user, isLoaded } = useUser();
  const { isSignedIn, signOut } = useClerkAuth();
  
  const userInfo: User | null = useMemo(() => {
    if (!user) return null;
    
    const role = user.publicMetadata?.role as Role;
    
    return {
      id: user.id,
      email: user.emailAddresses[0]?.emailAddress || '',
      name: `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.emailAddresses[0]?.emailAddress || 'User',
      role: role || 'reviewer', // 默认最低权限
    };
  }, [user]);
  
  return {
    user: userInfo,
    role: userInfo?.role,
    isLoaded,
    isSignedIn,
    signOut,
  };
}

